import type { TestFunction } from 'yup';

export const isWorkOrganizationNameNotOnlyIp: TestFunction<string> = (value) => {
  if (!value) {
    return true;
  }

  const compact = value.replace(/[.\s]/g, '').toUpperCase();
  return compact !== 'ИП';
};
